module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_pp3_8003.65d3c075.png";